import gql from 'graphql-tag';

export const ContentAttachmentsQuery = gql`
	query ContentAttachmentsQuery($contentId: ID!, $status: [String] = ["current"]) {
		content(id: $contentId, status: $status) {
			edges {
				node {
					id
					attachments {
						nodes {
							id
							title
							extensions {
								key
								value
							}
						}
					}
				}
			}
		}
	}
`;
